import React from 'react'
import { connect } from 'react-redux'
import CartItem from './CartItem'
import { CheckoutSection } from '../../components'
import { deleteItemAsync, updateItemQuantityAsync, updateItemQuantity } from './cartActionCreators'

const CartList = ({ items, onQuantityChange, onDelete, announcement }) => {
    const cartItems = items.map((item) => {
        return (
            <CartItem
                key={item.Id}
                item={item}
                onQuantityChange={onQuantityChange}
                onDelete={onDelete}

            />
        );
    });

    const subheader = <div className="cart-announcement" dangerouslySetInnerHTML={{ __html: announcement }} />;

    return (
        <CheckoutSection label={'Shopping Cart'} subheader={subheader}>
            {cartItems}
        </CheckoutSection>
    );
}

const cartListMapStateToProps = (state) => {
    return {
        items: state.entities.CartItems,
        announcement: state.ui.cartAnnouncement
    }
}

const cartListMapDispatchToProps = (dispatch) => {
    return {
        onQuantityChange: (id, value) => {
            dispatch(updateItemQuantityAsync({ id, qty: value }));
        },
        onDelete: (id, prevQty) => {
            if (typeof window !== 'undefined' && typeof window.confirm !== 'undefined' && window.confirm("Delete this item?")) {
                dispatch(deleteItemAsync({ id }))
            } else {
                dispatch(updateItemQuantity(id, prevQty > 0 ? prevQty : 1))
            }
        }
    }
}

const CartListContainer = connect(cartListMapStateToProps, cartListMapDispatchToProps)(CartList);

export default CartListContainer
